module.exports = __webpack_public_path__ + "static/media/claw.e4fefac9.jpg";